import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Button, FormControl, TextField } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import './authUserVerification.css'
import dayjs, { Dayjs } from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface AuthUserVerificationProps {
    onClose: () => void
    data: any
    handleResponse: (params: any, date: any) => void
}

interface EmiratesId {
    id: string;
    nationality: string;
    dob: string;
}

interface UserData {
    userEmail: string;
    userName: string;
    date?: Date;
}


interface ResetPasswordField {
    name: keyof UserData;
    type: string;
    label: string;
    disable: boolean
}

const AuthUserVerification = (props: AuthUserVerificationProps) => {

    const resetPasswordField: ResetPasswordField[] = [
        // { name: 'userName', type: 'text', label: 'Name', disable: true },
        // { name: 'userEmail', type: 'text', label: 'Email', disable: true },
        { name: 'date', type: 'date', label: 'Date', disable: false },
    ]
    const { control, handleSubmit, setValue, clearErrors } = useForm({
        // defaultValues: resetPasswordField.reduce((acc, field) => {
        //     acc[field.name] = '';
        //     return acc;
        // }, {} as Record<string, string>),
    });


    const [userData, setUserData] = useState<UserData>(props.data.data)

    useEffect(() => {
        setValue('userName', userData.userName)
        setValue('userEmail', userData.userEmail)
    }, [userData])

    useEffect(() => {
        // setUserData(props.data)
        // console.log(props.data, "Props dataaaaaaaaaaaaaaa")
    }, [props.data])
    console.log(userData)
    const onSubmit = (data: Record<string, string>) => {
        console.log(data, "Data")
        props.handleResponse(props.data, data.date)

    };

    const handleDate = (e: any) => {
        const date = e.$d
        console.log(date)
        const dateObject = new Date(date);

        // Extract the date part
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth() + 1; // Months are 0-based, so we add 1
        const day = dateObject.getDate();

        const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
        console.log(formattedDate, "Formatted date")
        setValue('date', formattedDate)
    }

    return (
        <div >
            <div className="modal-heading">
                <h4>Approve User</h4>
                <CloseIcon
                    className='modal-close-button'
                    onClick={() => { props.onClose() }}
                />
            </div>
            <div className='modal-body'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {resetPasswordField.map((item, index) => (
                        <div key={index} style={{ marginTop: '5px', width: '100%' }}>
                            <label className='label-container'>{item.label}</label>
                            <Controller
                                name={item.name}
                                control={control}
                                rules={{
                                    required: item.name === 'date' ? 'Date is required' : false,
                                }}
                                render={({ field, fieldState: { error }, formState, fieldState }) => (
                                    item.name === 'date' ? (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    {...field}
                                                    value={field.value ? dayjs(field.value) : null}
                                                    onChange={(date: Dayjs | null) => {
                                                        field.onChange(date);
                                                        handleDate(date);
                                                        if (date) {
                                                            clearErrors(item.name); // Clear error once a date is selected
                                                        }
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            error: !!error,
                                                            helperText: error ? error.message : null,
                                                            fullWidth: true,
                                                        },
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    ) : (
                                        <TextField
                                            {...field}
                                            type={item.type}
                                            variant="outlined"
                                            value={userData[item.name]}
                                            disabled={item.disable}
                                            fullWidth
                                            error={!!error}
                                            helperText={error ? error.message : null}
                                        />
                                    )
                                )}
                            />


                        </div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                        <Button variant='contained' type='submit'>Submit</Button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AuthUserVerification